module.exports = require('./gatsby-browser.ts');
